//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// defrag daily results card imports
import { IAttendeesProps } from "./TailoredDefragSummaryAttendeeStats.d";
import { fragments } from "./TailoredDefragSummaryAttendees.gql";
import * as s from "./TailoredDefragSummaryAttendeeStats.styles";
// other components
import { AvatarRow } from "@components/avatar-row";
import { niceName } from "@util/event.util";

//////////////////
// COMPONENT
//////////////////
// note: this recreates a lot of logic from AvatarRow... which is stupid
// but, unfortunately, the tooltips and data are different enough to necessitate it...
export class TailoredDefragSummaryAttendeesCmpt extends React.Component<IAttendeesProps> {
  private getToolTipContents = () => {
    const { calendarValueStrings, personList } = this.props;
    const calIdToValueMap: { [calendarId: string]: string[] } = calendarValueStrings.reduce(
      (accum: { [calendarId: string]: string[] }, cValueStrings) => {
        accum[cValueStrings.calendarId] = cValueStrings.valueStrings;
        return accum;
      },
      {},
    );

    return personList.list.map((person) => {
      const name = niceName(person, person.primaryEmail, true);
      const valueStrings = calIdToValueMap[person.primaryEmail];
      let tooltipString = (
        <div>
          <div>{name}:</div>Schedule improvements
        </div>
      );
      if (valueStrings && valueStrings.length) {
        tooltipString = (
          <div>
            <div>{name}:</div>
            {valueStrings.map((val, i) => (
              <div key={`${val}-${i}`}>{val}</div>
            ))}
          </div>
        );
      }
      return <span key={person.primaryEmail}>{tooltipString}</span>;
    });
  };

  public render() {
    const { personList } = this.props;
    const toolTipContents = this.getToolTipContents();
    return (
      <div style={s.teammates}>
        <AvatarRow
          customTooltips={toolTipContents}
          persons={personList.list}
          size="medium"
          maxAvatarCount={6}
        />
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const TailoredDefragSummaryAttendees = createFragmentContainer(
  TailoredDefragSummaryAttendeesCmpt,
  fragments,
);
